import React, { Component } from "react";

class AudioMessageEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: '',
      post_title: "",
      cover_photo_a: "",
      csrf_token: "",
      uploadedImage: "",
      audio: "",
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.alertMsg = this.alertMsg.bind(this);

    this.insert = this.insert.bind(this);
    this.update = this.update.bind(this);

    this.toggleEditorExecBtnColor = this.toggleEditorExecBtnColor.bind(this);
    this.image = this.image.bind(this);
    this.audio = this.audio.bind(this);

    this.validateImage = this.validateImage.bind(this);
    this.validateAudio = this.validateAudio.bind(this);

    this.uploadImage = this.uploadImage.bind(this);
  }

  alertMsg(elem, className, errorMessage) {
    elem.classList.remove("success-alert");
    elem.classList.remove("error-alert");

    elem.classList.add(className);
    elem.innerHTML = errorMessage;
  }

  toggleEditorExecBtnColor(elem) {
    if (elem.classList.contains("neutral")) {
      elem.classList.remove("neutral");
      elem.classList.add("green-fill");
    } else {
      elem.classList.add("neutral");
      elem.classList.remove("green-fill");
    }
    document.getElementById("audio_editor_frame").focus();
  }

  validateImage(image) {
    let alertElem = document.querySelector("#alert-23");
    if (image.name === "") {
      this.alertMsg(alertElem, "error-alert", "Please select an image");
      this.setState({ hasError: true });
      return false;
    }

    let extension = image.type
      .split("/")
      .pop()
      .toLowerCase();
    if (["jpg", "png", "jpeg"].indexOf(extension) === -1) {
      this.alertMsg(
        alertElem,
        "error-alert",
        "The selected file is not an image"
      );
      return false;
    }

    if (image.size > 4500000) {
      this.alertMsg(
        alertElem,
        "error-alert",
        "Image should not be more than 4mb"
      );
      return false;
    }
    return true;
  }

  validateAudio(audio) {
    let alertElem = document.querySelector("#alert-23");
    if (audio.name === "") {
      this.alertMsg(alertElem, "error-alert", "Please select an audio");
      this.setState({ hasError: true });
      return false;
    }

    let extension = audio.type
      .split("/")
      .pop()
      .toLowerCase();
    if (["ogg", "flac", "mp3", "mpeg"].indexOf(extension) === -1) {
      this.alertMsg(
        alertElem,
        "error-alert",
        "The selected file is not an audio"
      );
      return false;
    }
    return true;
  }

  image(e) {
    let alertElem = document.querySelector("#alert-23");

    this.alertMsg(alertElem, "success-alert", "Image is being uploaded...");

    let image = e.target.files[0];
    if (this.validateImage(image)) {
      this.uploadImage(image, alertElem);
    }
  }

  audio(e) {
    let alertElem = document.querySelector("#alert-23");

    this.alertMsg(alertElem, "success-alert", "Audio selected");
    this.setState({ audio: e.target.files[0] });
    document.querySelector('.editor-audio-name-dis').innerHTML = e.target.files[0].name
  }

  uploadImage(image, alertElem) {
    const formdata = new FormData();
    formdata.append("post_image", image);
    fetch(`${this.props.apiROOT}imageUpload`, {
      method: "post",
      body: formdata
    })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          if (this.state.uploadedImage === "") {
            this.setState({ uploadedImage: data.imageName });
          }

          let src = `${this.props.root}public/images/post_pic/${data.imageName}`;
          window.frames.cover_photo_a.document.execCommand(
            "insertimage",
            false,
            src
          );
          this.alertMsg(alertElem, "success-alert", "Image uploaded");
        } else {
          this.alertMsg(alertElem, "error-alert", "An error occurred");
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  insert(formdata) {
    let alertElem = document.querySelector("#alert-23");
    this.alertMsg(alertElem, "success-alert", "Please wait...");
    if (this.validateAudio(this.state.audio)) {
      fetch(`${this.props.apiROOT}post/insertArticle`, {
        method: "post",
        body: formdata
      })
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            this.alertMsg(alertElem, "success-alert", "Audio message posted");
            window.location.reload();
            this.props.toggleAudioMessageEditor();
          } else {
            this.alertMsg(alertElem, "error-alert", "An error occured");
          }
        });
    }
  }

  update(formdata) {
    let alertElem = document.querySelector("#alert-23");
    this.alertMsg(alertElem, "success-alert", "Please wait...");
    fetch(`${this.props.apiROOT}post/editArticle/${this.props.postID}`, {
      method: "post",
      body: formdata
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          window.location.reload();
          this.alertMsg(alertElem, "success-alert", "Audio message updated");
          this.props.toggleAudioMessageEditor(alertElem, "Audio");
          this.props.updatePostDOM(data.post);
        } else {
          this.alertMsg(alertElem, "error-alert", "An error occured");
        }
      });
  }

  onSubmit(e) {
    e.preventDefault();

    let editor = document.getElementById("audio_editor_frame");
    document.querySelector("#audio_editor_ta").value =
      editor.contentWindow.document.body.innerHTML;
    const cover_photo_a = document.querySelector("#audio_editor_ta").value;

    const title = document.querySelector(".editor-post-a-title").value;

    if (this.state.post_title.trim().length < 10 && title.trim().length < 5) {
      let alertElem = document.querySelector("#alert-23");
      this.alertMsg(alertElem, "error-alert", "Audio title is too short");
      return;
    }

    //match all image uploaded by this user
    let imageAry = cover_photo_a.match(/post_pic\/[^]+([png, jpg, gif, jpeg])/);
    let uploadedImage = imageAry ? imageAry[0].replace(/post_pic\//, "") : "";

    let formdata = new FormData();
    formdata.append("post_title", title);
    formdata.append("main_post", cover_photo_a);
    formdata.append("category", 'Message');
    formdata.append("post_image", uploadedImage);
    formdata.append("post_type", 'Audio');
    formdata.append("audio", this.state.audio == "" ? this.props.audio : this.state.audio);
    formdata.append("csrf_token", this.state.csrf_token);
    formdata.append("isJSeditor", 1);

    if (this.props.setter === "insert") {
      this.insert(formdata);
    } else if (this.props.setter === "update") {
      this.update(formdata);
    }
  }

  render() {

    if (this.props.setter == "update") {
      let editor = document.getElementById("audio_editor_frame");
      editor.contentWindow.document.designMode = "On";
      editor.contentWindow.document.body.innerHTML = this.props.mainPost;
    }


    return (
      <form
        className="editor shadow"
        id="create-audio-form"
      >
        <small id="alert-23" />
        <div className="input-wrapper">
          <input
            className="title editor-post-a-title"
            type="text"
            name="post_title"
            maxLength="200"
            placeholder="Title..."
            onChange={this.onChange}
            defaultValue={this.props.post_title}
          />
        </div>

        <div className="editor-exec-btn-wrapper editor-exec-btn-wrapper-audio">

          <label htmlFor="post-audio" className="editor-picture-btn neutral">
            Add Audio
          </label>
          <input
            type="file"
            id="post-audio"
            style={{ display: "none" }}
            accept=".ogg,.flac,.mp3" required="required"
            onChange={this.audio}
          />

          <label htmlFor="post-image" className="editor-picture-btn neutral" style={{ width: 200 }}>
            Add Cover Photo
          </label>
          <input
            type="file"
            id="post-image"
            style={{ display: "none" }}
            onChange={this.image}
          />
        </div>

        <div className="input-wrapper">
          <textarea
            id="audio_editor_ta"
            name="cover_photo_a"
            rows="10"
            onChange={this.onChange}
          />
          <iframe name="cover_photo_a" id="audio_editor_frame" ></iframe>
          <p><b>Audio name</b> - <span className="editor-audio-name-dis">{this.props.audio}</span></p>
        </div>

        <div className="input-wrapper">
          <button type="submit" className="btn"
            onClick={this.onSubmit}>
            {this.props.setter === "insert"
              ? "Add Audio"
              : "Update Audio"}
          </button>
        </div>
      </form>
    );
  }
}

export default AudioMessageEditor;
